import { defineStore } from "pinia";
import objectPath from "object-path";
import defaultLayout from "@/core/config/layoutConfig";
import { cloneDeep } from "@/core/utils/utils";
import { computed, ref } from "vue";

export const useLayoutConfigStore = defineStore("layoutConfig", () => {
  const config = ref(cloneDeep(defaultLayout));
  const getLayoutConfig = (path: string = "", defaultValue: any = null) => {
    return objectPath.get(config.value, path, defaultValue);
  };

  const setLayoutConfig = (payload: any) => {
    config.value = cloneDeep(payload);
  };

  const resetLayoutConfig = () => {
    config.value = cloneDeep(defaultLayout);
  };

  const asideEnabled = computed(() => !!getLayoutConfig("aside.self.display"));

  const headerMenuEnabled = computed(() => !!getLayoutConfig("header.menu.self.display"));

  return {
    config,
    getLayoutConfig,
    setLayoutConfig,
    resetLayoutConfig,
    headerMenuEnabled,
    asideEnabled,
  };
});
